const sections = {
  sections: {
    default: {
      py: [5, null, 6, 6],
      bg: 'background'
    },
    withMargin: {
      my: [5, null, 6, 6],
      bg: 'background'
    },
    tight: {
      bg: 'background'
    },
    white: {
      bg: 'white'
    },
    primary: {
      bg: 'primary'
    },
    rteSection: {
      py: [3, null, null, 3],
      bg: 'background'
    }
  }
}

export default sections
